import React, { useRef, useMemo, useState, useEffect } from 'react'
import { Divider, Paper } from '@mui/material';
import { Button } from '@mui/material';
import FormDialog from '../panel/modal';
import JoditEditor from 'jodit-react';
import Fab from '@mui/material/Fab';
import SaveIcon from '@mui/icons-material/Save';

import Swal from 'sweetalert2'
import axios from 'axios';
import api from '../../API/api';
import ViewCourses from '../table/viewCourses';
import { useParams, useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Loader from '../panel/loader';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AddStudenetForm = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    // console.log("okk===>>", location.state?.from);

    const [schools, setSchools] = useState();
    const [courses, setCourses] = useState();
    const [duration, setDuration] = useState();
    useEffect(() => {
        getSchool();

    }, []);


    // edit section
    useEffect(() => {
        if (props.modalData?.school_id) {
            getCourses(props.modalData.school_id);
            setFormdata({
                student_id: props.modalData.id,
                enrollment: props.modalData.enrollment,
                registration: props.modalData.registration,
                name: props.modalData.name,
                school: props.modalData.school_id,
                course: props.modalData.course_id,
                admissionYear: props.modalData.admissionYear,
                batch: props.modalData.batch,
                address: props.modalData.address,
                email: props.modalData.email,
                phone: props.modalData.phone,
                caste: props.modalData.caste,
                dob: props.modalData.dob,
            })
        }

    }, [props.modalData]);




    const getSchool = () => {
        api.getSchools().then((res) => {
            // console.log(res);
            setSchools(res.data.schools)
        })
            .catch((err) => {
                // console.log(err.response);
            })
    }

    const handelSchool = (e) => {
        setFormdata({
            ...formdata,
            [e.target.name]: e.target.value
        })

        setCourses('')
        // console.log(e.target.value);
        if (e.target.value) {
            getCourses(e.target.value)
        }
    }

    const getCourses = (id) => {
        api.getCourses(id).then((res) => {
            // console.log(res);
            setCourses(res.data.courses)
        })
            .catch((err) => {
                // console.log(err.response);
            })
    }

    const handleBatch = (e) => {
        setFormdata({
            ...formdata,
            [e.target.name]: e.target.value,
            batch: new Date(e.target.value.replace('-', '/') + '/01').getFullYear()
        })

    }


    const [formdata, setFormdata] = useState({
        enrollment: '',
        registration: '',
        name: '',
        school: '',
        course: '',
        admissionYear: '',
        batch: '',
        address: '',
        email: '',
        phone: '',
        caste: '',
        dob: '',

    })

    const handleForm = (e) => {
        setFormdata({
            ...formdata,
            [e.target.name]: e.target.value
        })

        if (e.target.name === 'course') {
            var course = courses.filter((x) => x.id == e.target.value)
            var duration = course[0].duration;
            setDuration(duration);

        }

    }

    const submitData = () => {

        if (formdata.name == '' || formdata.name == undefined) {
            Swal.fire({
                title: 'Error!',
                text: 'Name Cannot be empty !',
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            return;
        }
        if (formdata.admissionYear == '' || formdata.admissionYear == undefined) {
            Swal.fire({
                title: 'Error!',
                text: 'Admission Year Cannot be empty !',
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            return;
        }
        if (formdata.phone == '' || formdata.phone == undefined) {
            Swal.fire({
                title: 'Error!',
                text: 'Phone Cannot be empty !',
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            return;
        }
        if (formdata.dob == '' || formdata.dob == undefined) {
            Swal.fire({
                title: 'Error!',
                text: 'Date of Birth Cannot be empty !',
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            return;
        }

        const postData = new FormData();
        postData.append('enrollment', formdata.enrollment)
        postData.append('registration', formdata.registration)
        postData.append('name', formdata.name)
        postData.append('school', formdata.school)
        postData.append('course', formdata.course)
        postData.append('admissionYear', formdata.admissionYear)
        postData.append('batch', formdata.batch)
        postData.append('address', formdata.address)
        postData.append('email', formdata.email)
        postData.append('phone', formdata.phone)
        postData.append('caste', formdata.caste)
        postData.append('dob', formdata.dob)
        postData.append('student_id', formdata.student_id)
        if (location.state?.from === 'public') {
            postData.append('approve', 0)
            postData.append('status', 0)
            // console.log("public");

            // return;
        }
        else {
            // console.log("private");
            // return;
            postData.append('approve', 1)
            postData.append('status', 1)
        }


        axios.post(`${process.env.REACT_APP_MAIN_API}postStudent`, postData)
            .then((res) => {
                // console.log("=>", res);


                if (res.data.status === 200) {
                    // props.handleClose();
                    setStep(1);
                    Swal.fire({
                        title: 'Success!',
                        text: res.data.message,
                        icon: 'success',
                        confirmButtonText: 'Ok'
                    })

                    toast.success(res.data.message, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });

                    if (location.state?.from === 'public') {
                        navigate('/StudentLogin')
                    }
                }
                if (res.data.status === 409) {
                    toast.warn(res.data.message, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                }

            })
            .catch((err) => {
                // console.log(err.response);
                props.handleClose();
                Swal.fire({
                    title: 'Opps!',
                    text: 'Something Went Wrong !',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                }).then((el) => {
                    // console.log(el);
                    props.handleClickOpen();
                    return;
                })
            })
    }

    const [step, setStep] = useState(1);
    const [load, setLoad] = useState(false);

    const nextStep = () => {
        switch (step) {
            case 1:
                return (
                    <>
                        {form1()}
                    </>
                )

            case 2:
                return (
                    <>
                        {form2()}
                    </>
                )
            case 3:
                return (
                    <>
                        {form2()}
                    </>
                )
            default:
                { form1() };
                break;
        }

    }


    const stepper = () => {
        return (
            <>
                <Paper elevation={6}>
                    <Divider sx={{ borderBottomWidth: '1px', borderBottomColor: 'black' }} />
                    <div className='row justify-content-center p-2'>

                        <Fab color={step === 1 ? 'secondary' : ''} size='small' variant="extended" aria-label="edit">
                            <div className="row">
                                <div> <small>1  </small></div>
                            </div>
                        </Fab>
                        <Fab color={step === 2 ? 'secondary' : ''} size='small' variant="extended" aria-label="edit">
                            <div className="row">
                                <div> <small>2 </small></div>
                            </div>
                        </Fab>
                    </div>
                    <Divider sx={{ borderBottomWidth: '5px', borderBottomColor: 'black' }} />
                </Paper>
            </>
        )
    }


    const stepfooter = () => {
        return (
            <>

                <Paper elevation={6}>
                    <div className='p-2 mt-2'>

                        <div className='d-flex justify-content-between'>
                            <div>
                                {step !== 1 &&
                                    <Button variant='contained' color='secondary' onClick={() => setStep(1)}>Previous</Button>
                                }
                            </div>
                            <div>
                                {step !== 2 ?
                                    <Button variant='contained' onClick={() => setStep(2)}>Next</Button> :
                                    <>
                                        {props.modalData?.school_id ? <Button variant='contained' color='success' disabled={load ? true : false} onClick={submitData}>Update <SaveIcon fontSize='small' /></Button>
                                            :
                                            <Button variant='contained' color='success' disabled={load ? true : false} onClick={submitData}>Save <SaveIcon fontSize='small' /></Button>
                                        }
                                    </>

                                }
                            </div>
                        </div>

                    </div>
                </Paper>

            </>
        )
    }

    // React.useEffect(() => {
    //     setFormdata(props.modalData)
    //    
    // },[props])


    const form1 = () => {
        return (
            <>
                <Paper elevation={3}>
                    <div className='p-3'>
                        <div className="row">

                            <div className="col-md-12 form-group p-2">
                                <label for="">Student Name</label>
                                <input type="text" className="form-control" name='name' value={formdata.name} onChange={handleForm} id="" placeholder="Enter Student Name" />
                            </div>

                            <div className="col-md-6 form-group p-2">
                                <label for="">Roll No</label>
                                <input type="text" className="form-control" name='enrollment' value={formdata.enrollment} onChange={handleForm} id="" placeholder="" />
                            </div>
                            <div className="col-md-6 form-group p-2">
                                <label for="">Registration No</label>
                                <input type="text" className="form-control" name='registration' value={formdata.registration} onChange={handleForm} id="" placeholder="" />
                            </div>

                            <div className="col-md-6 form-group p-2">
                                <label for="">School</label>

                                <select name="school" value={formdata.school} className='form-control' onChange={handelSchool} id="">
                                    <option value="">-Select-</option>
                                    {schools && schools.map((el) => (
                                        <option value={el.id}>{el.schoolName}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-md-6 form-group p-2">
                                <label for="">Course</label>

                                <select name="course" value={formdata.course} onChange={handleForm} className='form-control' id="">
                                    <option value="">-Select-</option>
                                    {courses && courses.map((el) => (
                                        <option value={el.id}> {el.courseName} <span className='text-primary'> ({el.effected_from} - {el.effected_to}) </span> </option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-md-6 form-group p-2">
                                <label for="">Admission Year</label>
                                <input type="month" className="form-control" name='admissionYear' value={formdata.admissionYear} onChange={handleBatch} id="" placeholder="" />
                            </div>



                            <div className="col-md-6 form-group p-2">
                                <label for="">Batch</label>
                                <input type="text" className="form-control" name='batch' value={formdata.batch} onChange={handleForm} id="" placeholder="" />
                            </div>



                        </div>



                        {/* <div className='d-flex justify-content-between'>
                            <div>

                            </div>
                            <div>
                                <Button variant='contained' onClick={() => setStep(2)}>Next</Button>
                            </div>
                        </div> */}

                    </div>
                </Paper>
            </>
        )
    }

    const form2 = () => {
        return (
            <>
                <Paper elevation={3}>
                    <div className='p-3'>
                        <div className="row">

                            <div className="col-md-12 form-group p-2">
                                <label for="">Address</label>
                                <input type="text" className="form-control" name='address' value={formdata.address} onChange={handleForm} id="" placeholder="" />
                            </div>

                            <div className="col-md-6 form-group p-2">
                                <label for="">Email</label>
                                <input type="email" className="form-control" name='email' value={formdata.email} onChange={handleForm} id="" placeholder="" />
                            </div>
                            <div className="col-md-6 form-group p-2">
                                <label for="">Phone No</label>
                                <input type="number" className="form-control" name='phone' value={formdata.phone} onChange={handleForm} id="" placeholder="" />
                            </div>
                            <div className="col-md-6 form-group p-2">
                                <label for="">Caste</label>
                                {/* <input type="text" className="form-control" name='caste' value={formdata.caste} onChange={handleForm} id="" placeholder="" /> */}
                                <select name="caste" className="form-control" value={formdata.caste} onChange={handleForm} id="">
                                    <option value="">--Select--</option>
                                    <option value="General">General</option>
                                    <option value="OBC">OBC</option>
                                    <option value="SC">SC</option>
                                    <option value="ST(P)">ST(P)</option>
                                    <option value="ST(H)">STP(H)</option>
                                    <option value="Other">Other</option>
                                </select>

                            </div>
                            <div className="col-md-6 form-group p-2">
                                <label for="">Date of Birth</label>
                                <input type="date" className="form-control" name='dob' value={formdata.dob} onChange={handleForm} id="" placeholder="" />
                                
                            </div>



                        </div>
                        {/* <div className='d-flex justify-content-between'>
                            <div>

                                <Button variant='contained' color='secondary' onClick={() => setStep(1)}>Previous</Button>
                            </div>
                            <div>
                                <Button variant='contained' color='success' disabled={load ? true : false} onClick={submitData}>Save <SaveIcon fontSize='small' /></Button>
                            </div>
                        </div> */}
                    </div>
                </Paper>
            </>
        )
    }

    return (
        <>


            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
            {/* Same as */}
            <ToastContainer />


            <div className='p-2'>
                {stepper()}
                {nextStep()}
                {stepfooter()}

            </div>
        </>
    )
}

export default AddStudenetForm;